import { httpsCallable } from 'firebase/functions';
import { getFirebaseFunctions } from '@bookstore/shared/browser';
import { pincodeService } from './pincode.service';

class ShippingService {
  private get functions() {
    return getFirebaseFunctions();
  }

  /**
   * Validate pincode and get location details using Postal Pincode API
   */
  async validatePincode(pincode: string): Promise<{
    success: boolean;
    pincode?: string;
    city?: string;
    state?: string;
    district?: string;
    officeName?: string;
    deliveryAvailable?: boolean;
  }> {
    try {
      const details = await pincodeService.validatePincode(pincode);
      
      return {
        success: details.isValid,
        pincode: details.pincode,
        city: details.city,
        state: details.state,
        district: details.district,
        officeName: details.city, // Using city as office name
        deliveryAvailable: details.deliveryAvailable,
      };
    } catch (error) {
      console.error('Pincode validation error:', error);
      return {
        success: false,
      };
    }
  }

  /**
   * Calculate shipping cost
   * 
   * 🚧 TEMPORARY: India Post API not available yet
   * TODO: Uncomment the API call below when India Post API is ready
   */
  async calculateShippingCost(params: {
    destinationPincode: string;
    itemCount?: number;
    orderValue?: number;
    cod?: boolean;
  }): Promise<{
    success: boolean;
    tariff?: any;
    serviceable?: boolean;
    deliveryOffice?: string;
  }> {
    // 🔴 COMMENTED OUT - India Post API not available yet
    // TODO: Uncomment when India Post API credentials are ready
    // const fn = httpsCallable(this.functions, 'calculateShippingCost');
    // const result = await fn(params);
    // return result.data as any;

    // ✅ TEMPORARY HARDCODED LOGIC - Remove when India Post API is ready
    // Simple shipping calculation: Free for orders >= ₹500, else ₹50
    const shippingCost = (params.orderValue || 0) >= 500 ? 0 : 50;
    const gstRate = 0.18;
    const gstAmount = shippingCost * gstRate;
    const totalAmount = shippingCost + gstAmount;

    // const totalAmount = shippingCost;
    // const gstAmount = 0;
     


    return {
    success: true,
      serviceable: true,
      deliveryOffice: 'Local Post Office',
      tariff: {
        total_amount: shippingCost, // pre-GST
        base_amount: shippingCost,
        cgst: 0,
        sgst: 0,
        igst: 0,
        weight: (params.itemCount || 1) * 500,
        zone_description: 'Local Zone',
      },
    };
  }

  /**
   * Track shipment by order ID
   * 
   * 🚧 TEMPORARY: India Post tracking API not available yet
   * TODO: Uncomment the API call below when India Post API is ready
   */
  async trackShipment(orderId: string, shipmentId: string): Promise<{
    success: boolean;
    data?: any;
  }> {
    // 🔴 COMMENTED OUT - India Post tracking API not available yet
    // TODO: Uncomment when India Post API credentials are ready
    // const fn = httpsCallable(this.functions, 'trackShipment');
    // const result = await fn({ orderId, shipmentId });
    // return result.data as any;

    // ✅ TEMPORARY PLACEHOLDER - Admin will manually update tracking IDs
    return {
      success: false,
      data: {
        message: 'Tracking not available. Please check tracking ID with courier.',
      },
    };
  }

  /**
   * Track by tracking number (public)
   * 
   * 🚧 TEMPORARY: India Post tracking API not available yet
   * TODO: Uncomment the API call below when India Post API is ready
   */
  async trackByNumber(trackingNumber: string): Promise<{
    success: boolean;
    data?: any;
  }> {
    // 🔴 COMMENTED OUT - India Post tracking API not available yet
    // TODO: Uncomment when India Post API credentials are ready
    // const fn = httpsCallable(this.functions, 'trackShipment');
    // const result = await fn({ trackingNumber });
    // return result.data as any;

    // ✅ TEMPORARY PLACEHOLDER - Admin will manually update tracking IDs
    return {
      success: false,
      data: {
        message: 'Tracking not available. Please check tracking ID with courier.',
      },
    };
  }
}

export const shippingService = new ShippingService();